export const SEARCH_INPUT_MIN_LENGTH = 2;
export const DEBOUNCE_DURATIONS = {
    low: 500,
    medium: 700,
    high: 1000
};
